<button
  [id]="id"
  [class]="class"
  [type]="type"
  [ngClass]="[
    isAllowedGlobalStyling &&
    ((leftIcon && leftIcon !== 'none' && leftIcon !== '') ||
      (rightIcon && rightIcon !== 'none' && rightIcon !== ''))
      ? 'with-icon'
      : '',
    isAllowedGlobalStyling ? borderRadiusClass : ''
  ]"
  [disabled]="disabled || delayActive()"
  [class.is-disabled]="disabled || delayActive()"
  (click)="onClick()"
  [ngStyle]="buttonStyle"
>
  @if (delayActive()) {
  <span
    class="activation-delay-overlay"
    [style.animation-duration.s]="activationDelaySeconds()"
  ></span>
  }
  <mat-icon
    *ngIf="leftIcon && leftIcon !== ''"
    [ngStyle]="!isAllowedGlobalStyling || activeButtonType === buttonTypes.MENU ? leftIconSize : {}"
    [svgIcon]="leftIcon"
    [ngClass]="!isAllowedGlobalStyling ? 'button-icon-svg' : 'button-icon'"
  ></mat-icon>
  <!-- Label stays in the layout (just hidden) while loading, so the button keeps its
       content-derived width/height instead of shrinking to the spinner/loading text. -->
  <span class="finx-button-content" [class.finx-button-content-hidden]="isLoadingState">
    <ng-container
      *ngTemplateOutlet="
        buttonText;
        context: { labeltext: labeltext, class: class, isAllowedGlobalStyling: isAllowedGlobalStyling }
      "
    ></ng-container>
  </span>
  @if (isLoadingState) {
  <span class="finx-button-loading-overlay">
    @if (isAllowedGlobalStyling && globalLoadingIndicatorType() === loadingIndicatorTypes.ANIMATION) {
    <span class="finx-button-loading-spinner" aria-hidden="true"></span>
    } @else {
    <ng-container
      *ngTemplateOutlet="
        buttonLoadingText;
        context: {
          loadingText: (isAllowedGlobalStyling && globalLoadingText()) || loadingText,
          isAllowedGlobalStyling: isAllowedGlobalStyling
        }
      "
    ></ng-container>
    }
  </span>
  }
  <mat-icon
    *ngIf="rightIcon && rightIcon !== 'none' && rightIcon !== ''"
    [ngStyle]="!isAllowedGlobalStyling || activeButtonType !== buttonTypes.MENU ? rightIconSize : {}"
    [svgIcon]="rightIcon"
    [ngClass]="!isAllowedGlobalStyling ? 'ml-auto button-icon-svg' : 'button-icon right-icon'"
    [class]="rightIconClass"
  ></mat-icon>
</button>

<ng-template
  #buttonText
  let-labeltext="labeltext"
  let-class="class"
  let-isAllowedGlobalStyling="isAllowedGlobalStyling"
>
  <ng-container *ngIf="class.includes('btn-small'); else btnNormal">
    <small *ngIf="labeltext?.length" [innerHTML]="labeltext | safeHtml"></small>
  </ng-container>
  <ng-template #btnNormal>
    <div
      *ngIf="labeltext?.length"
      [class.buttonText]="isAllowedGlobalStyling"
      [innerHTML]="labeltext | safeHtml"
    ></div>
  </ng-template>
</ng-template>

<ng-template
  #buttonLoadingText
  let-loadingText="loadingText"
  let-isAllowedGlobalStyling="isAllowedGlobalStyling"
>
  <div
    *ngIf="loadingText?.length"
    [class.buttonText]="isAllowedGlobalStyling"
    [innerHTML]="loadingText | safeHtml"
  ></div>
</ng-template>
